import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const PrimaryProgramSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */

    const [form, setForm] = useState({
        heading: "",
        introduction_text: ""
    });

    /* IMAGES */
    const [image, setImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    /* ---------------- IMAGE STATES (CSR STYLE) ---------------- */
    const handleFileChange = (e) => {
        //setImage(e.target.files[0]);
        const file = e.target.files[0];
        setImage(file);

        if (file) {
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    /* ------------- Block State ------------------*/

    const [blocks, setBlocks] = useState([
        {
            block_type: "card_grid",
            heading: "",
            intro_1: "",
            items_1: [""],
            intro_2: "",
            items_2: [{ heading: "", content: "" }]
        },
        {
            block_type: "card_grid_simple",
            heading: "",
            intro: "",
            items: [""]
        }
    ]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, [school_slug]);

    useEffect(() => {
        console.log("BLOCKS USED BY UI:", blocks);
    }, [blocks]);

    const fetchContent = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/academic_page/get_primary/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { section, blocks: fetchedBlocks } = res.data.data;

                /* ---------- SECTION ---------- */
                if (section) {
                    setForm({
                        heading: section.heading || "",
                        introduction_text: section.introduction_text || ""
                    });

                    if (section.section_image) {
                        setPreviewImage(
                            `${baseAPIUrl}assets/images/academics/${section.section_image}?t=${Date.now()}`
                        );
                    }
                }

                /* ---------- CARD GRID BLOCK ---------- */
                /* ------------ BLOCKS --------------- */
                /* ---------- CARD GRID BLOCK ---------- */
                if (Array.isArray(res.data.data.blocks)) {
                    const fetchedBlocks = res.data.data.blocks;

                    setBlocks(prev =>
                        prev.map(block => {
                            const saved = fetchedBlocks.find(
                                b => b.block_type === block.block_type
                            );
                            if (!saved) return block;

                            let content = saved.content;
                            if (typeof content === "string") {
                                try {
                                    content = JSON.parse(content);
                                } catch {
                                    content = {};
                                }
                            }

                            if (block.block_type === "card_grid") {
                                return {
                                    block_type: "card_grid",
                                    heading: saved.heading || "",
                                    intro_1: content.intro_1 || "",
                                    items_1: content.items_1 || [""],
                                    intro_2: content.intro_2 || "",
                                    items_2: content.items_2 || [{ heading: "", content: "" }]
                                };
                            }

                            if (block.block_type === "card_grid_simple") {
                                return {
                                    block_type: "card_grid_simple",
                                    heading: saved.heading || "",
                                    intro: content.intro || "",
                                    items: content.items || [""]
                                };
                            }

                            return block;
                        })
                    );
                }



            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    /* HANDLERS */

    const updateIntro = (blockIndex, key, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[blockIndex][key] = value;
            return updated;
        });
    };

    const addItem1 = (blockIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items_1.length >= 4) return prev;
            updated[blockIndex].items_1.push("");
            return updated;
        });
    };

    const removeItem1 = (blockIndex, itemIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items_1.length <= 1) return prev;
            updated[blockIndex].items_1.splice(itemIndex, 1);
            return updated;
        });
    };

    const updateItem1 = (blockIndex, itemIndex, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[blockIndex].items_1[itemIndex] = value;
            return updated;
        });
    };

    const addItem2 = (blockIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items_2.length >= 3) return prev;

            updated[blockIndex] = {
                ...updated[blockIndex],
                items_2: [...updated[blockIndex].items_2, { heading: "", content: "" }]
            };
            return updated;
        });
    };

    const removeItem2 = (blockIndex, itemIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items_2.length <= 1) return prev;

            const items = updated[blockIndex].items_2.filter((_, i) => i !== itemIndex);
            updated[blockIndex] = {
                ...updated[blockIndex],
                items_2: items
            };
            return updated;
        });
    };

    const updateItem2 = (blockIndex, itemIndex, field, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            const items = updated[blockIndex].items_2.map((obj, i) =>
                i === itemIndex ? { ...obj, [field]: value } : obj
            );

            updated[blockIndex] = {
                ...updated[blockIndex],
                items_2: items
            };
            return updated;
        });
    };

    const updateSimple = (blockIndex, key, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[blockIndex] = { ...updated[blockIndex], [key]: value };
            return updated;
        });
    };

    const updateSimpleItem = (blockIndex, itemIndex, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            const items = [...updated[blockIndex].items];
            items[itemIndex] = value;
            updated[blockIndex] = { ...updated[blockIndex], items };
            return updated;
        });
    };

    const addSimpleItem = (blockIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[blockIndex] = {
                ...updated[blockIndex],
                items: [...updated[blockIndex].items, ""]
            };
            return updated;
        });
    };

    const removeSimpleItem = (blockIndex, itemIndex) => {
        setBlocks(prev => {
            const updated = [...prev];
            if (updated[blockIndex].items.length <= 1) return prev;
            updated[blockIndex] = {
                ...updated[blockIndex],
                items: updated[blockIndex].items.filter((_, i) => i !== itemIndex)
            };
            return updated;
        });
    };


    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };


    /* ---------------- Submit ---------------- */
    const sanitizeBlocks = (blocks) => {
        return blocks.map(block => {
            if (block.block_type === "card_grid") {
                return {
                    block_type: "card_grid",
                    heading: block.heading || "",
                    content: JSON.stringify({
                        intro_1: block.intro_1 || "",
                        items_1: block.items_1.map(i => i ?? ""),
                        intro_2: block.intro_2 || "",
                        items_2: block.items_2.map(obj => ({
                            heading: obj.heading || "",
                            content: obj.content || ""
                        }))
                    })
                };
            }

            if (block.block_type === "card_grid_simple") {
                return {
                    block_type: "card_grid_simple",
                    heading: block.heading || "",
                    content: JSON.stringify({
                        intro: block.intro || "",
                        items: block.items
                    })
                };
            }

            // ✅ always return block
            return block;
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);
            const cleanBlocks = sanitizeBlocks(blocks);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(form));
            formData.append("blocks", JSON.stringify(cleanBlocks));
            if (image) {
                formData.append("section_image", image);
            }
            const res = await axios.post(
                `${baseAPIUrl}admin/academic_page/add_edit_primary`,
                formData,
                { withCredentials: true }
            );
            await fetchContent();
            setMessage(res.data.message);
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Primary-program section</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Academic page</li>
                                <li class="breadcrumb-item active">Primary-program section</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit Primary-program section</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}
                                        {/* Heading */}
                                        <input type="hidden" name="school_slug" value={school_slug}></input>
                                        <div className="form-group">
                                            <label>Heading of section</label>
                                            <input
                                                type="text"
                                                name="heading"
                                                className="form-control"
                                                placeholder="Heading of section"
                                                value={form.heading}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Introduction text */}
                                        <div className="form-group">
                                            <label>Introduction text</label>
                                            <textarea
                                                name="introduction_text"
                                                rows="5"
                                                className="form-control"
                                                placeholder="Introduction text"
                                                value={form.introduction_text}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Blocks content */}
                                        <div className="form-group">
                                            {blocks.map((block, index) => (
                                                <div key={index} className="border p-3 mb-3">

                                                    <strong>{block.block_type.toUpperCase()}</strong>


                                                    {block.block_type === "card_grid" && (
                                                        <>
                                                            {/* Intro 1 */}
                                                            <textarea
                                                                className="form-control mb-2"
                                                                placeholder="Intro text"
                                                                value={block.intro_1}
                                                                onChange={e => updateIntro(index, "intro_1", e.target.value)}
                                                            />

                                                            {/* Items 1 */}
                                                            {block.items_1.map((item, i) => (
                                                                <div key={i} className="d-flex gap-2 mb-2">
                                                                    <input
                                                                        className="form-control"
                                                                        placeholder={`Item ${i + 1}`}
                                                                        value={item}
                                                                        onChange={e => updateItem1(index, i, e.target.value)}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger"
                                                                        onClick={() => removeItem1(index, i)}
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </div>
                                                            ))}

                                                            <button
                                                                type="button"
                                                                className="btn btn-success mb-3"
                                                                disabled={block.items_1.length >= 4}
                                                                onClick={() => addItem1(index)}
                                                            >
                                                                + Add Item
                                                            </button>

                                                            {/* Intro 2 */}
                                                            <textarea
                                                                className="form-control mb-2"
                                                                placeholder="Intro 2"
                                                                value={block.intro_2}
                                                                onChange={e => updateIntro(index, "intro_2", e.target.value)}
                                                            />

                                                            {/* Items 2 */}
                                                            {block.items_2.map((obj, i) => (
                                                                <div key={i} className="border p-2 mb-2">
                                                                    <input
                                                                        className="form-control mb-1"
                                                                        placeholder="Card heading"
                                                                        value={obj.heading}
                                                                        onChange={e => updateItem2(index, i, "heading", e.target.value)}
                                                                    />
                                                                    <textarea
                                                                        className="form-control"
                                                                        placeholder="Card content"
                                                                        value={obj.content}
                                                                        onChange={e => updateItem2(index, i, "content", e.target.value)}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger mt-2"
                                                                        onClick={() => removeItem2(index, i)}
                                                                    >
                                                                        Remove Card
                                                                    </button>
                                                                </div>
                                                            ))}

                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                disabled={block.items_2.length >= 3}
                                                                onClick={() => addItem2(index)}
                                                            >
                                                                + Add Card
                                                            </button>
                                                        </>
                                                    )}

                                                    {block.block_type === "card_grid_simple" && (
                                                        <>
                                                            <input
                                                                className="form-control mb-2"
                                                                placeholder="Section heading"
                                                                value={block.heading}
                                                                onChange={e => updateSimple(index, "heading", e.target.value)}
                                                            />

                                                            <textarea
                                                                className="form-control mb-2"
                                                                placeholder="Intro text"
                                                                value={block.intro}
                                                                onChange={e => updateSimple(index, "intro", e.target.value)}
                                                            />

                                                            {block.items.map((item, i) => (
                                                                <div key={i} className="d-flex gap-2 mb-2">
                                                                    <input
                                                                        className="form-control"
                                                                        placeholder={`Item ${i + 1}`}
                                                                        value={item}
                                                                        onChange={e => updateSimpleItem(index, i, e.target.value)}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger"
                                                                        onClick={() => removeSimpleItem(index, i)}
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </div>
                                                            ))}

                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                disabled={block.items.length >= 4}
                                                                onClick={() => addSimpleItem(index)}
                                                            >
                                                                + Add Item
                                                            </button>
                                                        </>
                                                    )}

                                                </div>
                                            ))}

                                        </div>

                                        {/* image uploD */}
                                        <div className="form-group">
                                            <label>Section image</label>

                                            <div className="input-group">
                                                <div className="custom-file">
                                                    <input
                                                        type="file"
                                                        className="custom-file-input"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label className="custom-file-label">
                                                        {image ? image.name : "Choose file"}
                                                    </label>
                                                </div>
                                                <div className="input-group-append">
                                                    <span className="input-group-text">Upload</span>
                                                </div>
                                            </div>

                                            {/* Existing Image Preview */}

                                            <div className="mt-2">
                                                <img
                                                    src={
                                                        previewImage
                                                    }
                                                    alt="Preview"
                                                    className="img-fluid img-bordered"
                                                    style={{ width: "100px" }}
                                                />
                                            </div>

                                        </div>

                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default PrimaryProgramSection;